import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';

export const awsAppsyncClient = new AWSAppSyncClient({
  url: process.env.REACT_APP_GRAPHQL_SUBSCRIPTIONS_ENDPOINT,
  region: process.env.REACT_APP_AWS_APPSYNC_REGION,
  auth: {
    type: AUTH_TYPE.API_KEY,
    apiKey: process.env.REACT_APP_GRAPHQL_SUBSCRIPTIONS_API_KEY,
  },
  disableOffline: true,
});
